export const siteHeaderSelector = "#site-header";
const headerClearance = 12;

/** Scroll a page section into view without letting the fixed header cover it. */
export function scrollToSection(selector: string) {
  const target = document.querySelector<HTMLElement>(selector);
  if (!target) return false;

  const headerHeight = document.querySelector<HTMLElement>(siteHeaderSelector)?.getBoundingClientRect().height ?? 0;
  const targetTop = Math.max(
    0,
    window.scrollY + target.getBoundingClientRect().top - headerHeight - headerClearance,
  );

  window.scrollTo({ top: targetTop, behavior: "auto" });
  return true;
}
